import React, { Fragment } from "react";
import { Grid } from "@mui/material";

import Appbar from "./NewAppDrawer.component";
import AutoLogout from "../../utils/autoLogout";
import { useAuth } from "../../context/Auth.context";

const Layout = () => {
  const auth = useAuth();
  const getLogouttime = auth?.user?.associateDetails?.filter((data) => {
    return data?.dealership_id === auth?.user?.dealership_id;
  });
  console.log("getLogouttime", getLogouttime);
  return (
    <Fragment>
      {auth?.user?.role == "manager" || auth?.user?.role == "employee" ? (
        <AutoLogout logout_time={getLogouttime[0]?.logout_time}>
          <Grid container sx={{ marginTop: "10px" }}>
            <Appbar />
          </Grid>
        </AutoLogout>
      ) : (
        <Grid container sx={{ marginTop: "10px" }}>
          <Appbar />
        </Grid>
      )}
    </Fragment>
  );
};

export default Layout;
